function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import classnames from 'classnames';
import MaskedInput from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import InputGroup from "./InputGroup";
import InputGroupAddon from "./InputGroupAddon";
/**
 * In the case where the user enters an extra "." at the end of the input the default behavior will
 * be to remove the original decimal point and keep the new one, resulting in the value being
 * multiplied by 100.  If we detect an additional decimal point we can ignore the extra character.
 */

function preventMultipleDecimalPoint(conformedValue, config) {
  var result = conformedValue;

  if (config.rawValue.match(/\..*\./)) {
    result = config.previousConformedValue;
  }

  return result;
}

var defaultProps = {
  allowDecimal: true,
  allowNegative: false,
  includeThousandsSeparator: true
}; // TODO support I18n

var CurrencyInput = function CurrencyInput(_ref) {
  var _ref$allowDecimal = _ref.allowDecimal,
      allowDecimal = _ref$allowDecimal === void 0 ? defaultProps.allowDecimal : _ref$allowDecimal,
      _ref$allowNegative = _ref.allowNegative,
      allowNegative = _ref$allowNegative === void 0 ? defaultProps.allowNegative : _ref$allowNegative,
      className = _ref.className,
      _ref$includeThousands = _ref.includeThousandsSeparator,
      includeThousandsSeparator = _ref$includeThousands === void 0 ? defaultProps.includeThousandsSeparator : _ref$includeThousands,
      inputProps = _ref.inputProps,
      size = _ref.size,
      state = _ref.state,
      type = _ref.type,
      props = _objectWithoutProperties(_ref, ["allowDecimal", "allowNegative", "className", "includeThousandsSeparator", "inputProps", "size", "state", "type"]);

  var inputClassNames = classnames('form-control', inputProps && inputProps.className);

  var maskedProps = _objectSpread(_objectSpread(_objectSpread({}, inputProps), props), {}, {
    className: inputClassNames,
    // There is a weird bug in the MaskedInput where if the "value" prop gets set to null the
    // input value gets set to "_".  Setting guide to false instead of undefined solves the
    // problem.
    guide: false,
    mask: createNumberMask({
      allowDecimal: allowDecimal,
      allowNegative: allowNegative,
      includeThousandsSeparator: includeThousandsSeparator,
      prefix: ''
    }),
    pipe: preventMultipleDecimalPoint
  });

  return (
    /*#__PURE__*/
    React.createElement(InputGroup, {
      size: size,
      className: className
    },
    /*#__PURE__*/
    React.createElement(InputGroupAddon, {
      addonType: "prepend"
    }, "$"),
    /*#__PURE__*/
    React.createElement(MaskedInput, maskedProps))
  );
};

CurrencyInput.displayName = "CurrencyInput";
CurrencyInput.displayName = 'CurrencyInput';
CurrencyInput.defaultProps = defaultProps;
export default CurrencyInput;